/*
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { Component, ElementRef, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { AppSettings } from "./app.settings";
import { EnvService } from "./env.service";
import {NGXLogger} from "ngx-logger";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  constructor(public elementRef: ElementRef,
              public translate: TranslateService,
              private environmentSettings: EnvService,
              private titleService: Title) {
  }

  ngOnInit(): void {
    AppSettings.init(this.elementRef.nativeElement.dataset, this.environmentSettings);

    this.translate.addLangs(this.environmentSettings.SupportedLocales);
    this.translate.setDefaultLang(this.environmentSettings.DefaultLocale);

    // Change the title on the anchor page (i.e. the index.html page) based
    // on our locale.
    this.translate.get("title").subscribe((translatedTitle: string) => {
      this.titleService.setTitle(translatedTitle);
    });
  }
}
